import { useEffect } from 'react';

import { getRegisterUrl } from '../../../constants/ssoConstants';
import { setRefCode } from '../../../utils/setRefCode';

export const RegisterCallback = () => {
  useEffect(() => {
    setRefCode();

    const registerUrl = getRegisterUrl();
    window.location.href = registerUrl.toString();
  }, []);

  return null;
};
